import * as S from "./BlackFridayBottomBanner.styles";
import BannerBgMp4 from "./assets/banner-bg.mp4";
import BannerBgJpg from "./assets/banner-bg.jpg";
import BannerBgMobileMp4 from "./assets/banner-bg-mobile.mp4";
import BannerBgMobileJpg from "./assets/banner-bg-mobile.jpg";

import { ClosePrimaryIcon } from "@ubnt/icons";
import { Cookies } from "react-cookie";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "hooks/useTranslation";
import { useSiteSettings } from "context/SiteSettingsContext";
import { StoreId } from "@ubnt/store.core/lib/types";
import { BREAKPOINTS } from "layout";
import { useMedia } from "react-use";

const cookies = new Cookies();

const BLACK_FRIDAY_COOKIE_NAME = "ui_bf_closed";
const BANNER_CLOSED_VALUE = 1;

export const BlackFridayBottomBanner = () => {
  const isMobile = useMedia(BREAKPOINTS.TABLET_AND_DOWN);
  const { routes, store } = useSiteSettings();

  const { t } = useTranslation();

  const [isClosedLocal, setIsClosedLocal] = useState(false);
  const isBannerHidden =
    cookies.get(BLACK_FRIDAY_COOKIE_NAME) === BANNER_CLOSED_VALUE;

  const onCloseBanner = useCallback(
    (event?: React.MouseEvent<HTMLButtonElement>) => {
      event?.preventDefault();

      setIsClosedLocal(true);
      cookies.set(BLACK_FRIDAY_COOKIE_NAME, String(BANNER_CLOSED_VALUE), {
        path: "/",
        expires: undefined,
        secure: true,
        sameSite: "strict",
      });
    },
    [],
  );

  useEffect(() => {
    if (isBannerHidden) {
      return;
    }

    // Indonesia store doesn't have BF deals
    if (store.id === StoreId.In) {
      onCloseBanner();
    }
  }, [isBannerHidden, onCloseBanner, store.id]);

  if (isClosedLocal || isBannerHidden) {
    return null;
  }

  return (
    <S.FixedContainer
      href={routes.store.tags("black-friday")}
      target="_blank"
      rel="noopener noreferrer"
    >
      <S.Wrapper
        size="desktop"
        noVerticalMargin
        $spacing={{ top: 0, bottom: 0 }}
      >
        {isMobile ? (
          <S.StyledMobileVideo
            src={BannerBgMobileMp4}
            poster={BannerBgMobileJpg}
            autoPlay
            muted
            loop
            playsInline
          />
        ) : (
          <S.StyledVideo
            src={BannerBgMp4}
            poster={BannerBgJpg}
            autoPlay
            muted
            loop
            playsInline
          />
        )}

        <S.TextContainer>
          <S.Description>{t("blackFriday.banner.description")}</S.Description>
          <S.Disclaimer>{t("blackFriday.banner.disclaimer")}</S.Disclaimer>
        </S.TextContainer>

        <S.TransparentButton aria-label="Close Banner" onClick={onCloseBanner}>
          <ClosePrimaryIcon size={20} color="#fff" />
        </S.TransparentButton>
      </S.Wrapper>
    </S.FixedContainer>
  );
};
